// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Common = require("../utils/Common.bs.js");
var MM_context = require("../mm-utils/MM_context.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var MM_cmp_editor = require("./MM_cmp_editor.bs.js");
var MM_cmp_pe_index = require("../explorer/MM_cmp_pe_index.bs.js");
var MM_cmp_settings = require("./MM_cmp_settings.bs.js");
var MM_wrk_settings = require("../worker/MM_wrk_settings.bs.js");
var Expln_React_Modal = require("@expln/utils/src/main/react-components/Expln_React_Modal.bs.js");
var Expln_React_Column = require("@expln/utils/src/main/react-mui-components/Expln_React_Column.bs.js");
var Expln_React_UseTabs = require("@expln/utils/src/main/react-components/Expln_React_UseTabs.bs.js");
var Local_storage_utils = require("../ui-utils/Local_storage_utils.bs.js");
var Styles = require("@mui/material/styles");
var MM_cmp_click_counter = require("./MM_cmp_click_counter.bs.js");
var MM_cmp_context_selector = require("./MM_cmp_context_selector.bs.js");
var Expln_React_ContentWithStickyHeader = require("@expln/utils/src/main/react-components/Expln_React_ContentWithStickyHeader.bs.js");

function createInitialState(settings) {
  return {
          settings: settings,
          settingsV: 0,
          srcs: [],
          ctx: MM_context.createContext(undefined, undefined, undefined),
          ctxV: 0
        };
}

function setCtx(st, srcs, ctx) {
  return {
          settings: st.settings,
          settingsV: st.settingsV,
          srcs: srcs,
          ctx: ctx,
          ctxV: st.ctxV + 1 | 0
        };
}

function setSettings(st, settings) {
  return {
          settings: settings,
          settingsV: st.settingsV + 1 | 0,
          srcs: st.srcs,
          ctx: st.ctx,
          ctxV: st.ctxV
        };
}

var mainTheme = Styles.createTheme({
      palette: {
        grey: {
          main: "#e0e0e0"
        }
      }
    });

var $$location = window.location;

var initialStateSafeBase64 = new URLSearchParams($$location.search).get("editorState");

var editorInitialStateJsonStr = (initialStateSafeBase64 == null) ? Local_storage_utils.locStorReadString(MM_cmp_editor.editorStateLocStorKey) : (window.history.replaceState("removing editorState from the URL", "", $$location.origin + $$location.pathname), Common.safeBase64ToStr(initialStateSafeBase64));

function MM_cmp_root(props) {
  var modalRef = Expln_React_Modal.useModalRef(undefined);
  var match = Expln_React_UseTabs.useTabs(undefined);
  var updateTabs = match.updateTabs;
  var activeTabId = match.activeTabId;
  var tabs = match.tabs;
  var match$1 = React.useState(function () {
        return createInitialState(MM_cmp_settings.settingsReadFromLocStor(undefined));
      });
  var setState = match$1[1];
  var state = match$1[0];
  var reloadCtx = React.useRef(null);
  var actCtxUpdated = function (srcs, newCtx, settingsOpt) {
    var settings = settingsOpt !== undefined ? settingsOpt : state.settings;
    MM_context.moveConstsToBegin(newCtx, settings.parens);
    Curry._1(setState, (function (__x) {
            return setCtx(__x, srcs, newCtx);
          }));
  };
  var actSettingsUpdated = function (newSettings) {
    Curry._1(setState, (function (__x) {
            return setSettings(__x, newSettings);
          }));
    MM_cmp_settings.settingsSaveToLocStor(newSettings);
    actCtxUpdated(state.srcs, state.ctx, newSettings);
  };
  React.useEffect((function () {
          Curry._1(updateTabs, (function (st) {
                  if (Expln_React_UseTabs.getTabs(st).length !== 0) {
                    return st;
                  }
                  var match = Expln_React_UseTabs.addTab(st, "Settings", false, /* Settings */0);
                  var match$1 = Expln_React_UseTabs.addTab(match[0], "Editor", false, /* Editor */1);
                  return Expln_React_UseTabs.openTab(match$1[0], match$1[1]);
                }));
        }), []);
  return React.createElement(Styles.ThemeProvider, {
              theme: mainTheme,
              children: React.createElement(Expln_React_ContentWithStickyHeader.make, {
                    top: 0,
                    header: React.createElement(Expln_React_Column.make, {
                          children: Caml_option.some(null)
                        }, React.createElement(MM_cmp_context_selector.make, {
                              modalRef: modalRef,
                              webSrcSettings: state.settings.webSrcSettings,
                              onUrlBecomesTrusted: (function (url) {
                                  actSettingsUpdated(MM_wrk_settings.markUrlAsTrusted(state.settings, url));
                                }),
                              onChange: (function (srcs, ctx) {
                                  actCtxUpdated(srcs, ctx, undefined);
                                }),
                              reloadCtx: reloadCtx
                            }), Curry._1(match.renderTabs, undefined)),
                    content: (function (contentTop) {
                        return React.createElement(Expln_React_Column.make, {
                                    children: Caml_option.some(null)
                                  }, tabs.map(function (__x) {
                                        var match = __x.data;
                                        var tmp;
                                        if (typeof match === "number") {
                                          switch (match) {
                                            case /* Settings */0 :
                                                tmp = React.createElement(MM_cmp_settings.make, {
                                                      modalRef: modalRef,
                                                      ctx: state.ctx,
                                                      settingsVer: state.settingsV,
                                                      settings: state.settings,
                                                      onChange: actSettingsUpdated
                                                    });
                                                break;
                                            case /* Editor */1 :
                                                tmp = React.createElement(MM_cmp_editor.make, {
                                                      modalRef: modalRef,
                                                      settingsV: state.settingsV,
                                                      settings: state.settings,
                                                      srcs: state.srcs,
                                                      preCtxV: state.ctxV,
                                                      preCtx: state.ctx,
                                                      top: contentTop,
                                                      reloadCtx: reloadCtx,
                                                      initialStateJsonStr: editorInitialStateJsonStr
                                                    });
                                                break;
                                            case /* ExplorerIndex */2 :
                                                tmp = React.createElement(MM_cmp_pe_index.make, {
                                                      settingsVer: state.settingsV,
                                                      settings: state.settings,
                                                      preCtxVer: state.ctxV,
                                                      preCtx: state.ctx
                                                    });
                                                break;
                                            
                                          }
                                        } else {
                                          tmp = React.createElement(MM_cmp_click_counter.make, {
                                                title: match.label
                                              });
                                        }
                                        return React.createElement("div", {
                                                    key: __x.id,
                                                    style: {
                                                      display: __x.id === activeTabId ? "block" : "none"
                                                    }
                                                  }, tmp);
                                      }), React.createElement(Expln_React_Modal.make, {
                                        modalRef: modalRef
                                      }));
                      })
                  })
            });
}

var make = MM_cmp_root;

exports.createInitialState = createInitialState;
exports.setCtx = setCtx;
exports.setSettings = setSettings;
exports.mainTheme = mainTheme;
exports.$$location = $$location;
exports.editorInitialStateJsonStr = editorInitialStateJsonStr;
exports.make = make;
/* mainTheme Not a pure module */
